module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "align-center": "",
      "fill-height": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-card', {
    staticClass: "elevation-5"
  }, [_c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formValid),
      callback: function($$v) {
        _vm.formValid = $$v
      },
      expression: "formValid"
    }
  }, [_c('v-text-field', {
    ref: "userName",
    attrs: {
      "autocomplete": "new-password",
      "prepend-icon": "mdi-account-outline",
      "name": "userName",
      "label": "Имя пользователя",
      "type": "text",
      "rules": [_vm.rules.required]
    },
    on: {
      "input": function($event) {
        return _vm.checkAttributes()
      }
    },
    model: {
      value: (_vm.userName),
      callback: function($$v) {
        _vm.userName = $$v
      },
      expression: "userName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    ref: "email",
    attrs: {
      "prepend-icon": "mdi-email-outline",
      "name": "mail",
      "label": "E-mail",
      "type": "email",
      "rules": [_vm.rules.required, _vm.rules.email]
    },
    on: {
      "input": function($event) {
        return _vm.checkAttributes()
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "autocomplete": "new-password",
      "prepend-icon": "mdi-lock",
      "name": "password",
      "label": "Пароль",
      "type": "password",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Зарегистрировать организацию"
    },
    model: {
      value: (_vm.registerLegal),
      callback: function($$v) {
        _vm.registerLegal = $$v
      },
      expression: "registerLegal"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "mdi-domain",
      "label": "ИНН",
      "rules": [_vm.rules.inn],
      "disabled": !_vm.registerLegal
    },
    on: {
      "input": function($event) {
        return _vm.legalInnInput()
      }
    },
    model: {
      value: (_vm.legalInn),
      callback: function($$v) {
        _vm.legalInn = $$v
      },
      expression: "legalInn"
    }
  }), _vm._v(" "), (_vm.legalErrorText && _vm.legalErrorText !== '') ? _c('div', {
    staticClass: "ml-4 text-xs-left"
  }, [_vm._v("\n            " + _vm._s(_vm.legalErrorText) + "\n          ")]) : _c('div', {
    staticClass: "ml-4 font-weight-medium"
  }, [_vm._v(_vm._s(_vm.legalName))])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "",
      "disabled": !_vm.formValid || (_vm.registerLegal && !_vm.legalCanRegister)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.registerAccount()
      }
    }
  }, [_vm._v("Зарегистрироваться")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "margin-top": "14px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "6px"
    }
  }, [_vm._v("Уже есть учетная запись?")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$router.push('/login')
      }
    }
  }, [_vm._v("Войти")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-381d6203","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./webapp/components/Register.vue
// module id = 480
// module chunks = 0